import { render, staticRenderFns } from "./Hoteldetials.vue?vue&type=template&id=5d6d2b81"
import script from "./Hoteldetials.vue?vue&type=script&setup=true&lang=js"
export * from "./Hoteldetials.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Hoteldetials.vue?vue&type=style&index=0&id=5d6d2b81&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports